import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@/store/store.js';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App.jsx';
import 'react-multi-date-picker/styles/backgrounds/bg-dark.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Provider>
  </StrictMode>,
);
